module.exports = __webpack_public_path__ + "fontawesome-webfont.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.woff?v=4.7.0
// module chunks = styles